"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACInputNumber = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var FormInputLabel_1 = __importDefault(require("./FormInputLabel"));
var ACInputNumber = function (props) {
    var handleChange = function (e) {
        var rawValue = e.target.value;
        // Allow only digits and dot
        var newValue = rawValue.replace(/[^0-9.]/g, '');
        // Remove multiple dots
        var parts = newValue.split('.');
        if (parts.length > 2) {
            newValue = parts[0] + '.' + parts.slice(1).join('');
        }
        newValue = newValue.replace(/^0+(?=\d)/, '');
        if (props.max !== undefined && newValue !== '') {
            var numericValue = parseFloat(newValue);
            if (!isNaN(numericValue) && numericValue > props.max) {
                newValue = String(props.max);
            }
        }
        if (props.onChange) {
            props.onChange(newValue);
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: props === null || props === void 0 ? void 0 : props.containerClassName, children: [(0, jsx_runtime_1.jsx)(FormInputLabel_1.default, __assign({}, props)), (0, jsx_runtime_1.jsx)(antd_1.ConfigProvider, { theme: {
                    token: {
                        colorBgContainerDisabled: props.disabledColor || '',
                    },
                }, children: (0, jsx_runtime_1.jsx)(antd_1.Input, { ref: props.ref, placeholder: props.placeholder, addonBefore: props.addonBefore, value: props.value, disabled: props.disabled, id: props.id || '', suffix: props.suffix, prefix: props.prefix, type: "text", status: props.required && props.errorText ? 'error' : '', className: "apx-ui_input__text ".concat(props.color || 'primary', " ").concat(props.className), name: props.name, onChange: handleChange }) }), props.required && props.errorText && ((0, jsx_runtime_1.jsx)("p", { className: props.errorClassName, children: props.errorText }))] }));
};
exports.ACInputNumber = ACInputNumber;
